<div>
	<ng-container *ngIf="data?.content?.items[0]?.iframe">
		<uis-video-iframe [iframe]="iframeData"></uis-video-iframe>
	</ng-container>
	<div class="loose-text" [innerHTML]="data.content?.items[0]?.content"></div>
</div>
